import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// import {NavbarComponent} from '../../navbar/navbar.component';
import { Subscription } from 'rxjs';
import { MyLearningService } from '../../learner/my-learning/my-learning.service';
import { BaseService } from '../../shared-service/base.service';
import { MyTasksService } from '../../learner/my-tasks/my-tasks.service';

declare var $: any;
declare var google: any;

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})

export class SideMenuComponent implements OnInit, OnDestroy {

  MenuList: Array<Text> = [];
  //params: Object = {};
  latestUrl: any;
  notStartedLearning: number = 0;
  startedLearning: number = 0;
  completedLearning: number = 0;
  expiredLearning: number = 0;

  /* Learning Summary*/
  params: Object = {};
  summaryItems: Array<any> = [];
  errorObj: Object | any = {};
  tempLearningTypeID: any;
  latestId: any = 0;
  isTrainingHistory: boolean = false;
  EnableScript: boolean | any;

  subs: Subscription | any;
  public currentItem: string | any;
  /* Learning Summary*/

  constructor(public myTasksService: MyTasksService, private route: ActivatedRoute, private router: Router, public bs: BaseService, public myLearningService: MyLearningService) {
    console.log('info', "Loaded SideMenuComponent");
    this.bs.log('info', "Loaded LearningSummaryComponent");
    this.errorObj['err'] = false;
    let pieChartPath = "assets/js/pie-chart.js";
    $.getScript(pieChartPath, (res:any, status:any) => {
      if (status == "success") {
        this.EnableScript = true;
      }
    });
  }

  ngOnInit() {    
    console.log('info', 'ngOnInit SideMenuComponent');
    /* Learning Summary */
    this.params = {};
    this.summaryItems = [];
    this.isTrainingHistory = this.bs.isTrainingHistory;
    this.subs = this.route.params.subscribe((param) => {
      console.log('LearningSummaryComponent params', param);
      this.summaryItems = [];
      if (Object.keys(param).length > 0) {
        this.isTrainingHistory = this.bs.isTrainingHistory;
        this.refreshLearning(false);
      }
      else {
        this.refreshLearning(false);
      }
    });
    /* Learning SUmmary */
  }

  GetLearningStatus() {
    let param = {};
    this.myTasksService.getLearningStatus(param, "****").then((data:any) => {
      this.notStartedLearning = data["NotStartedLearning"];
      this.startedLearning = data["StartedLearning"]
      this.completedLearning = data["CompletedLearning"];
      this.expiredLearning = data["ExpiredLearning"];
    }, (data) => {
      this.bs.log('error', 'Error in getting list');
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  /* Learning Summary Starts*/
  refreshLearning(refreshLearningList: boolean) {
    if (this.isTrainingHistory) {
      this.myLearningService.getTrainingHistorySummaryFromServer(this.params, "****").then((data:any) => {
        this.summaryItems = data['learningSummaryItem'];
        this.tempLearningTypeID = this.summaryItems[0]['LearningTypeID'];
        if (Object.keys(this.summaryItems).length > 0) {
          this.tempLearningTypeID = this.summaryItems[0]['LearningTypeID'];
          this.initPieChart();
        }
        /*Default navigation to Overall Summary*/
        this.latestId = 0
        if (refreshLearningList)
          this.routeTo();
      }, (data) => {
        this.bs.log('error', 'Error in getting list');
      });
    }
    else if (this.bs.isReadAndSign) {
      this.routeTo();
    }
    else {
      this.myLearningService.getSummaryFromServer(this.params, "****").then((data:any) => {
        this.summaryItems = data['learningSummaryItem'];
        if (Object.keys(this.summaryItems).length > 0) {
          this.tempLearningTypeID = this.summaryItems[0]['LearningTypeID'];
          this.initPieChart();
        }
        /*Default navigation to Overall Summary*/
        this.latestId = 0
        if (refreshLearningList)
          this.routeTo();
      }, (data) => {
        this.bs.log('error', 'Error in getting list');
      });
    }
  }
  routeTo() {
    if (this.bs.isLrngClnder) {
      this.bs.isLrngClnder = true;
      this.router.navigate([this.bs.getDirectPath('tsk_mdl'), { outlets: { currentTaskList: ['calender-list', { date: new Date().getTime() }] } }], { relativeTo: this.route });
    }
    else if (this.bs.isReadAndSign) {
      this.router.navigate([this.bs.getDirectPath('tsk_mdl'), { outlets: { currentTaskList: ['read-and-sign', { date: new Date().getTime(), StatusType: "A", id: 0, filterBy: "0", assignedFilterBy: "0" }] } }], { relativeTo: this.route });
    }
    else {
      this.bs.isLearningType = true;
      this.bs.isShowAssignedFilter = true;
      this.router.navigate([this.bs.getDirectPath('tsk_mdl'), { outlets: { currentTaskList: ['current-task-list', { ResultFilterId: this.latestId, date: new Date().getTime() }] } }], { relativeTo: this.route });
    }
  }

  initPieChart() {
    //@TODO this.logger.log('ngAfterViewChecked LearningSummaryComponent');
    /*START -- Jquery widget for pie chart*/
    setTimeout(() => {
      if (this.EnableScript) {
        $('.progress-circle-green').pieChart({
          barColor: '#2ab4ce',
          trackColor: '#ffffff',
          lineCap: 'round',
          lineWidth: 8,
          size: 86,
          onStep: function (from:any, to:any, percent:any) {
            $(this.element).find('.pie-value').text(Math.round(percent) + '%');
          }
        });
        $('.progress-circle-red').pieChart({
          barColor: '#f46567',
          trackColor: '#ffffff',
          lineCap: 'round',
          lineWidth: 8,
          size: 86,
          onStep: function (from:any, to:any, percent:any) {
            $(this.element).find('.pie-value').text(Math.round(percent) + '%');
          }
        });
      }
    }, 500);
    /*END -- */
  }

  loadLearningList(action:any) {
    this.tempLearningTypeID = action.LearningTypeID;
    this.latestId = action.LearningTypeID;
    console.log("new Design......");
    console.log(action.LearningTypeID);
    console.log(action.LearningTypeID);
    this.routeTo();
  }

  trackBySummaryList(index: number, item: any) {
    return item['LearningTypeID'];
  }
  /* Learning Summary Ends*/

}
